module.exports = __webpack_public_path__ + "static/ASAPP-33d31789e2082944aefd486e502221d9.jpg";